<div
    [ngClass]="
        tableOnly
            ? 'rounded-2xl border border-gray-200/90 bg-white/95 shadow-sm dark:border-[#191e3a] dark:bg-[#0e1726] dark:shadow-none ' +
              (padded ? 'p-4' : '')
            : 'overflow-hidden rounded-2xl border border-gray-200/90 bg-white shadow-sm dark:border-[#191e3a] dark:bg-[#0c1220] dark:shadow-none'
    "
>
    <div
        *ngIf="!tableOnly"
        class="page-body-panel__toolbar border-b border-gray-300/50 bg-[#e8eaed] px-4 py-4 dark:border-[#2a3548] dark:bg-[#1a2332]"
    >
        <ng-content select="[pageToolbar]"></ng-content>
    </div>
    <div
        class="page-body-panel__table"
        [ngClass]="tableOnly ? '' : padded ? 'bg-white px-4 pb-4 pt-3 dark:bg-[#0c1220]' : 'bg-white dark:bg-[#0c1220]'"
    >
        <ng-content></ng-content>
    </div>
</div>
